import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";

const ImpersonationBanner = () => {
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    setIsImpersonating(localStorage.getItem("impersonating") === "true");
  }, []);

  const handleReturn = () => {
    const adminToken = localStorage.getItem("admin_token");
    const adminUserId = localStorage.getItem("admin_userId");
    const adminCompanyId = localStorage.getItem("admin_companyId");
    const adminProfile = localStorage.getItem("admin_profile");

    if (adminToken) {
      localStorage.setItem("token", adminToken);
      localStorage.setItem("userId", adminUserId);
      localStorage.setItem("companyId", adminCompanyId);
      localStorage.setItem("profile", adminProfile);

      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_userId");
      localStorage.removeItem("admin_companyId");
      localStorage.removeItem("admin_profile");
      localStorage.removeItem("impersonating");

      window.location.href = "/espejo";
    }
  };

  if (!isImpersonating) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
        color: "white",
        padding: "8px 24px",
        borderRadius: 50,
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      <span>Impersonando usuario</span>
      <Button
        size="small"
        variant="contained"
        onClick={handleReturn}
        startIcon={<ExitToApp />}
        style={{
          background: "white",
          color: "#e74c3c",
          fontWeight: 700,
          borderRadius: 20,
          textTransform: "none",
        }}
      >
        Volver al Admin
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
